let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("f1WN5"), load("4fCJZ"), load("bAbyV")]).then(() => parcelRequire('bHS4c'));